import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.scrollToBottom()
    }

    scrollToBottom() {
        this.element.scrollTop = this.element.scrollHeight
    }

    #observer = null

    initialize() {
        // Optional: Observe changes to scroll when new messages arrive
        this.observer = new MutationObserver(() => {
            this.scrollToBottom()
        })

        this.observer.observe(this.element, {
            childList: true,
            subtree: true
        })
    }

    disconnect() {
        if (this.observer) {
            this.observer.disconnect()
        }
    }
}
